import React, { useState, useEffect, useDeferredValue, Suspense } from "react";
import Row from "react-bootstrap/Row";
import loadForecast from "../api/forecastApi";
import { useUnit } from "../context/UnitContext";
import DailyForecast from "./DailyForecast";
import BusyIndicator from "./BusyIndicator";

import "../../css/Forecast.css";

const Forecast = ({ coordinates }) => {
  const [forecast, setForecast] = useState([]);
  const unit = useUnit();
  const defferedForecast = useDeferredValue(forecast);
  const isStale = forecast !== defferedForecast;

  useEffect(() => {
    loadForecast(coordinates, handleResponse, unit);
  }, [coordinates, unit]);

  const handleResponse = ({ daily }) => {
    setForecast(daily);
  };

  return (
    <Suspense fallback={BusyIndicator}>
      <Row className={isStale ? "Forecast-stale" : "Forecast-actual"}>
        {defferedForecast.slice(0, 6).map((weatherData, index) => (
          <DailyForecast data={weatherData} key={index} />
        ))}
      </Row>
    </Suspense>
  );
};

export default Forecast;
